import React from 'react';
import './Contact.css';
import { PiPhoneIncomingThin } from "react-icons/pi";
import { PiLaptopThin } from "react-icons/pi";
import { PiMapPinLineThin } from "react-icons/pi";
import { PiLinkedinLogoThin } from "react-icons/pi";
import { PiChatCircleTextThin } from "react-icons/pi";

const Contact: React.FC = () => {
  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2>Contact</h2>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <h3>Phone</h3>
              <div className="phone-wrapper">
                <div className="icon-container phone-icon-container">
                  {PiPhoneIncomingThin({ className: "contact-icon" })}
                </div>
                <div className="phone-info">
                  <p className="contact-label">Text or Call</p>
                  <p className="phone-number"><a href="tel:+12139154322">(213) 915-4322</a></p>
                </div>
              </div>
            </div>

            <div className="contact-item">
              <h3>Service Areas</h3>
              <div className="service-area">
                <div className="icon-container map-icon-container">
                  {PiMapPinLineThin({ className: "contact-icon" })}
                </div>
                <p>
                  In-person: South Bay
                  <br />
                  Los Angeles area
                </p>
              </div>
              <div className="service-area">
                <div className="icon-container laptop-icon-container">
                  {PiLaptopThin({ className: "contact-icon" })}
                </div>
                <p>Remote: Available for families anywhere</p>
              </div>
            </div>

            <div className="contact-item">
              <h3>Connect</h3>
              <div className="social-links">
                <a
                  href="https://g.page/r/CWCyVpZLHsgyEBM"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <div className="icon-container social-icon-container">
                    {PiChatCircleTextThin({ className: "social-icon" })}
                  </div>
                  Google Reviews
                </a>
                <a
                  href="https://www.linkedin.com/in/roxanne-massumi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <div className="icon-container social-icon-container">
                    {PiLinkedinLogoThin({ className: "social-icon" })}
                  </div>
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
